import cn from 'clsx'

import { type ServicesHero as ServicesHeroType } from '../../../../../apps/benmax/src/types/sanity.types'

import { getSanityLink } from 'shared-functions'

import { Button, Copy } from 'shared-components'

import s from './ServicesHero.module.sass'

function ServicesHero({ title, copy, link }: ServicesHeroType) {
    const _link = link?.linkType === 'internal' || link?.linkType === 'external' ? getSanityLink(link) || null : null

    return (
        <section className={s.ServicesHero}>
            <div className={cn(s.Cont, 'container')}>
                <div className={s.Title}>{title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}</div>
                <div className={s.Content}>
                    {copy && (
                        <div className={s.Copy}>
                            <Copy copy={copy} size="large" />
                        </div>
                    )}
                    {_link && <Button url={_link?.url || ''} title={_link?.title || ''} />}
                </div>
            </div>
        </section>
    )
}

export default ServicesHero
